import { initializeIcons, setIconOptions } from "@fluentui/react";
import { App } from "App";
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "react-query";
import { Provider } from "react-redux";
import "index.css";
import store from "./store";

const queryClient: QueryClient = new QueryClient();

initializeIcons();
setIconOptions({ disableWarnings: true });

const root: ReactDOM.Root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

// Suppress benign ResizeObserver errors from Fluent UI virtualizer
// This error is harmless and occurs due to layout recalculations
const resizeObserverErr = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends resizeObserverErr {
  constructor(callback: ResizeObserverCallback) {
    super((entries, observer) => {
      // Wrap callback in requestAnimationFrame to prevent loop errors
      window.requestAnimationFrame(() => {
        callback(entries, observer);
      });
    });
  }
};

const ignoreResizeObserverError = (event: ErrorEvent) => {
  if (
    event.message === "ResizeObserver loop limit exceeded" ||
    event.message ===
      "ResizeObserver loop completed with undelivered notifications."
  ) {
    event.stopImmediatePropagation();
    event.preventDefault();
    return true;
  }
};

// Use capture phase to catch before React's error overlay
window.addEventListener("error", ignoreResizeObserverError, true);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient} contextSharing>
        <App />
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>,
);
